import React, {Component, ReactElement} from 'react';
import '../../styles/Header.css';
import accountLogo from "../../img/account.svg";
import logo from "../../img/studio_logo.svg"
import {Link} from "react-router-dom";
import AccountNavContainer from "../containers/AccountNavContainer";
import classNames from "classnames";
import ShowHideMenu from "./ShowHideMenu";

interface HeaderState {
  accountSelected: boolean;
}

export interface HeaderProps {
  fetchSession: () => void;
  loginNotRequired: boolean;
  children?: React.ReactChildren;
}

class Header extends Component<HeaderProps, HeaderState> {
  constructor(props: HeaderProps) {
    super(props);

    this.state = {
      accountSelected: false
    };

    this.accountVisibleChange = this.accountVisibleChange.bind(this);
  }

  componentDidMount() {
    if (!this.props.loginNotRequired) {
      this.props.fetchSession();
    }
  }

  accountVisibleChange(visible: boolean) {
    this.setState({
      accountSelected: visible
    });
  }

  render() {
    const accountClasses = classNames("AccountButton", {
      AccountButtonSelected: this.state.accountSelected
    });

    return (
      <header className={"header-wrapper"}>
        <div className="Header header-layout">
          <div className="Item HomeItem">
            <Link className="HomeLink" to={"/projects"} title={"Studio Home"}>
              <img src={logo} alt="Studio"/>
            </Link>
          </div>
          {!this.props.loginNotRequired ?
            <div className="Item item--right">
              <ShowHideMenu menu={<AccountNavContainer/>}
                            onVisibleChange={this.accountVisibleChange}>
                <button className={accountClasses} title={"Account"}>
                  <img src={accountLogo} alt="Account"/>
                  <p className={"visuallyHidden"}>Account</p>
                </button>
              </ShowHideMenu>
            </div>
          : "" }
        </div>
        {this.props.children}
      </header>
    )
  }
}

export default Header;
